const state = {
  loaded: 0,
  loading: false
}

const mutations = {
  SET_DOWNLOAD_FIELD (state, { field, value }) {
    state[field] = value
  }
}

export default {
  state,
  mutations
}
